module.exports = __webpack_public_path__ + "img/ID.4b9180e1.png";